/** Review Mode left pane — high-resolution original scan (P32 → upgraded
 * Feb 2026 to the retained-original document viewer with zoom, pan,
 * rotate and source-page navigation; legacy rows fall back to the OCR
 * thumbnail with an honest notice).
 * June 2026: OCR field-provenance highlights — bounding boxes for
 * extracted fields render over the scan; the box for the form field the
 * reviewer is editing lights up. */
import React from 'react';
import { Spinner } from '@phosphor-icons/react';
import DocumentPageViewer from '../DocumentPageViewer';

const ScanViewer = ({
  loading,
  timesheetId,
  widthPct = 70,
  highlights = [],
  activeHighlightId = null,
}) => (
  <div
    className="bg-slate-950 relative overflow-hidden flex flex-col"
    style={{ width: `${widthPct}%` }}
    data-testid="review-scan-pane"
  >
    {loading || !timesheetId ? (
      <div className="flex-1 flex items-center justify-center">
        <Spinner size={32} className="animate-spin text-indigo-400" />
      </div>
    ) : (
      <DocumentPageViewer
        timesheetId={timesheetId}
        className="flex-1"
        highlights={highlights}
        activeHighlightId={activeHighlightId}
      />
    )}
  </div>
);

export default ScanViewer;
